export default __webpack_public_path__ + "static/media/Papel-Comercial-PT.a67a76fe.png";